import React, { useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { useForm } from 'react-hook-form'

import { theme } from '../../themes/theme'
import { StyledDialog, FlexEndContainer, FlexDialogContent, Form, FlexEndButtonErrorContainer } from '../styles/Containers'
import { WarningMessage } from '../common/UserMessage'
import { Checkbox, FormControlLabel } from '../styles/Checkbox'
import Button, { SecondaryButton } from '../common/Button'
import { BoldFormTitle, ErrorText } from '../styles/Text'
import pirTerminology from '../../util/pirTerminology'

const Label = styled(FormControlLabel)`
  margin: -8px 0;
`

const Red = styled.span`
  color: ${theme.colors.error};
`

function SameEmailAlert({ sameOwner = false, sameStrata = false, isVisible, onCancel = () => {}, onConfirm = () => {} }) {
  const { register, handleSubmit, formState, reset } = useForm({ shouldUseNativeValidation: false })

  function handleCancel() {
    reset()
    onCancel()
  }

  if (!sameOwner && !sameStrata) handleCancel()

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = isVisible
    }
  }, [])

  const onSubmit = () => onConfirm()

  const sameString = pirTerminology.getSameContactPhrase({ sameOwner, sameStrata })
  const verificationPhrase = pirTerminology.getSameContactVerificationPhrase({ sameOwner, sameStrata })

  const getLabel = () => (
    <>
      I verify that I am also the {verificationPhrase}.<Red> *</Red>
    </>
  )

  const error = !!formState.errors.verification
  const helperText = formState.errors?.verification?.message

  return (
    <StyledDialog fullWidth open={isVisible} onClose={() => handleCancel()} keepMounted={false}>
      <FlexDialogContent>
        <Form>
          <BoldFormTitle>Alert</BoldFormTitle>
          <WarningMessage>
            The entered {sameString} and requestor have the same email. If this is incorrect, please cancel and update the emails before proceeding.
          </WarningMessage>
          <FlexEndButtonErrorContainer gap="0">
            <Label {...register('verification', { required: 'You must verify before submitting.' })} control={<Checkbox />} label={getLabel()} />
            {error && <ErrorText role="alert">{helperText}</ErrorText>}
          </FlexEndButtonErrorContainer>
          <FlexEndContainer>
            <SecondaryButton onClick={() => handleCancel()}>Cancel</SecondaryButton>
            <Button onClick={handleSubmit(onSubmit)}>Confirm</Button>
          </FlexEndContainer>
        </Form>
      </FlexDialogContent>
    </StyledDialog>
  )
}

SameEmailAlert.propTypes = {
  sameOwner: PropTypes.bool,
  sameStrata: PropTypes.bool,
  isVisible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func
}

export default SameEmailAlert
